<template>
  <div id="company-wrap">
    <div id="section-1">
      <div class="section-wrap">
        <div class="section-title">{{ $t('contactUs.title') }}</div>
      </div>
    </div>
    <div id="section-2">
      <div id="float-section">
        <p>
          {{ $t('contactUs.desc.1') }} <a :href="`mailto:${supportEmail}?Subject=Enquiries`">{{ supportEmail }}</a>
        </p>
        <p>{{ $t('contactUs.desc.2') }}</p>
        <p>{{ $t('contactUs.desc.3') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getterTypes } from '@/store/getter-types';
import { mapGetters } from 'vuex';

export default {
  name: 'ContactUs',
  data() {
    return {
      supportEmailEng: 'support@grxtrade.com',
      supportEmailCn: 'support_cn@grxtrade.com',
      supportEmail: ''
    };
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Lang])
  },
  mounted() {
    this.supportEmail = this.supportEmailEng;
    const currentLang = this.Getter_Lang;

    if (currentLang) {
      if (currentLang.code === 'zh_CN' || currentLang.code === 'zh_TW') {
        this.supportEmail = this.supportEmailCn;
      }
    }
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      document.getElementById('company-wrap').scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
#company-wrap {
  font-size: 16px;

  #section-1 {
    display: flex;
    align-items: center;
    background-color: #f7f9fe;
    color: #000000;
    min-height: 20vh;
    padding: 15px 40px 80px;

    .section-wrap {
      margin: 0 auto;
      max-width: 1000px;

      .section-title {
        font-size: 1.9em;
        font-weight: 300;
        line-height: 50px;
        text-align: center;
      }
    }
  }

  #section-2 {
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    min-height: 45vh;
    padding-bottom: 50px;
    position: relative;

    #float-section {
      background-color: #ffffff;
      font-size: 0.9em;
      max-width: 600px;
      margin: -80px auto 20px;
      padding: 50px;
      // position: absolute;
      // top: 0;

      a {
        color: rgb(0, 0, 238);
      }

      p {
        text-align: justify;
      }
    }
  }
}

@media screen and (max-width: 575px) {
  #company-wrap {
    font-size: 14px;
  }
  #section-1 {
    min-height: 15vh;
    padding-top: 25px;
  }
  #section-2 {
    min-height: 40vh;
    #float-section {
      margin: -50px auto 20px;
      padding: 20px;
    }
  }
}
</style>
